import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import { useParams, useNavigate } from "react-router-dom";
import BreadCrumb from "app/components/BreadCrumb";
import { useTranslation } from "react-i18next";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import AddOrderModal from "app/containers/CommonModal/AddOrderModal";
import QuotesTable from "./components/QuotesTable";
import QuotesDetails from "./components/QuotesDetails";
import { reducer, sliceKey } from "./redux/slice";
import { quotesSaga } from "./redux/saga";
import { useStyles } from "./styles";

const getDirection = (language: string) => {
  return language === "hw" || language === "he" ? "rtl" : "ltr";
};

const Quotes = () => {
  const styles = useStyles();
  const { t, i18n } = useTranslation();
  const { quoteId } = useParams();
  const navigate = useNavigate();

  const direction = getDirection(i18n.language);

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: quotesSaga,
  });

  return (
    <Box className={styles.container}>
      {quoteId ? (
        <Box className={styles.detailsPage} dir={direction}>
          <Box className={styles.detailsBreadcrumb} dir={direction}>
            <ArrowForwardIcon
              className={styles.breadcrumbArrow}
              onClick={() => navigate("/quotes")}
            />

            <FolderOutlinedIcon className={styles.breadcrumbIcon} />

            <Typography
              className={styles.breadcrumbParent}
              onClick={() => navigate("/quotes")}
            >
              {t("QUOTES.TITLE")}
            </Typography>

            <Typography className={styles.breadcrumbSlash}>/</Typography>

            <Typography className={styles.breadcrumbCurrent}>
              {t("QUOTES.DETAILS.TITLE")}
            </Typography>
          </Box>

          <Box className={styles.detailsScroll}>
            <QuotesDetails quoteId={quoteId} />
          </Box>
        </Box>
      ) : (
        <Box className={styles.scrollContent} dir={direction}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("QUOTES.TITLE")} iconPosition="end" />

            <Box className={styles.pageBody}>
              <QuotesTable />
            </Box>
          </Box>
        </Box>
      )}
      <AddOrderModal />
    </Box>
  );
};

export default Quotes;